import { render } from "./StudyProblemsCategoryDetail.vue?vue&type=template&id=46718460&scoped=true"
import script from "./StudyProblemsCategoryDetail.vue?vue&type=script&lang=js"
export * from "./StudyProblemsCategoryDetail.vue?vue&type=script&lang=js"

import "./StudyProblemsCategoryDetail.vue?vue&type=style&index=0&id=46718460&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46718460"]])

export default __exports__